/* Aqua di Polo — yeni bölümler için ortak davranışlar. */
(function () {
  'use strict';

  /* Para biçimi.

     Mağazanın Shopify ayarı `899.50TL` üretiyor: ondalık nokta, binlik virgül,
     TL bitişik. Sunucu tarafını `adp-money` parçacığıyla düzeltmiştik ama JS
     ile güncellenen fiyatlar (yan sepet, adet değişimi, varyant seçimi,
     ücretsiz kargo mesajı) `window.money_format` üzerinden gidiyordu ve eski
     biçimde kalıyordu.

     Shopify'ın formatMoney'i `amount_with_comma_separator` anahtarını
     tanıyor: ondalık virgül, binlik nokta. TL'den önceki karakter bölünmez
     boşluk (U+00A0) — dar ekranda "TL" alt satıra kaymasın diye.

     Asıl düzeltilmesi gereken yer Shopify > Ayarlar > Para birimi biçimi.
     Orası düzeltilirse bu blok silinebilir. Çoklu para birimi kapalı
     (show_multiple_currencies=false), o yüzden çakışma yok. */
  window.money_format = '<span class="money">{{amount_with_comma_separator}} TL</span>';
  if (window.Shopify) { window.Shopify.money_format = window.money_format; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var nodes = document.querySelectorAll('.adp-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Shopify tema düzenleyicide bölüm yeniden yüklendiğinde tekrar bağla.
  document.addEventListener('shopify:section:load', reveal);
})();

/* Ürün rayı okları */
(function () {
  'use strict';

  function bindRails(root) {
    /* Koku aileleri ve gözlük seçkisi de yana kaydırmalı şeride çevrildi;
       aynı ok mantığını onlara da bağlıyoruz. Ayrı bir betik yazmak yerine
       kaydırıcı ve öğe seçicilerini genişletmek yetiyor. */
    (root || document).querySelectorAll('.adp-rail, .adp-families').forEach(function (rail) {
      var box = rail.querySelector('[data-adp-rail-scroller]:not([hidden])')
             || rail.querySelector('[data-adp-rail-scroller]');
      var prev = rail.querySelector('[data-adp-rail-prev]');
      var next = rail.querySelector('[data-adp-rail-next]');
      if (!box || !prev || !next || box.dataset.adpBound) return;
      box.dataset.adpBound = '1';

      function step() {
        var first = box.querySelector('.adp-rail__item, .adp-families__item');
        var w = first ? first.getBoundingClientRect().width : box.clientWidth / 3;
        var gap = parseFloat(getComputedStyle(box).columnGap || '12') || 12;
        return Math.max(1, Math.floor(box.clientWidth / (w + gap))) * (w + gap);
      }

      var nav = prev.parentElement;

      function sync() {
        var max = box.scrollWidth - box.clientWidth - 2;
        /* İçerik ekrana sığıyorsa kaydırılacak bir şey yok — iki pasif ok
           göstermek yerine kontrolleri tamamen kaldırıyoruz. */
        if (nav) nav.hidden = max <= 0;
        prev.disabled = box.scrollLeft <= 2;
        next.disabled = box.scrollLeft >= max;
      }

      prev.addEventListener('click', function () { box.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { box.scrollBy({ left: step(), behavior: 'smooth' }); });
      box.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindRails(); });
  } else {
    bindRails();
  }
  document.addEventListener('shopify:section:load', function (e) { bindRails(e.target); });
})();


/* Ürün rayı sekmeleri */
(function () {
  'use strict';

  function bindTabs(scope) {
    (scope || document).querySelectorAll('[data-adp-rail]').forEach(function (rail) {
      var tabs = rail.querySelectorAll('[data-adp-rail-tab]');
      if (!tabs.length || rail.dataset.adpTabsBound) return;
      rail.dataset.adpTabsBound = '1';

      var panels = rail.querySelectorAll('[data-adp-rail-panel]');

      function show(n) {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-adp-rail-tab') === n ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-adp-rail-panel') !== n;
        });
        var vis = rail.querySelector('[data-adp-rail-scroller]:not([hidden])');
        if (vis) vis.scrollLeft = 0;
        rail.dispatchEvent(new CustomEvent('adp:rail-change'));
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-adp-rail-tab')); });
        t.addEventListener('keydown', function (e) {
          var list = Array.prototype.slice.call(tabs);
          var i = list.indexOf(t);
          var next = e.key === 'ArrowRight' ? list[i + 1] : e.key === 'ArrowLeft' ? list[i - 1] : null;
          if (!next) return;
          e.preventDefault();
          next.focus();
          show(next.getAttribute('data-adp-rail-tab'));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindTabs(); });
  } else {
    bindTabs();
  }
  document.addEventListener('shopify:section:load', function (e) { bindTabs(e.target); });
})();

/* Hızlı sepete ekleme */
(function () {
  'use strict';

  var DONE = 'Sepete eklendi';
  var FAIL = 'Eklenemedi';

  function bind(scope) {
    (scope || document).querySelectorAll('[data-adp-quick-add]').forEach(function (btn) {
      if (btn.dataset.adpBound) return;
      btn.dataset.adpBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var label = btn.querySelector('[data-adp-quick-label]');
        var original = label ? label.textContent : '';

        btn.setAttribute('data-state', 'loading');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add ' + r.status);
            return r.json();
          })
          .then(function () {
            btn.setAttribute('data-state', 'done');
            if (label) label.textContent = DONE;
            // Ella'nın sepet arayüzü bu olayları dinliyor
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            setTimeout(function () {
              btn.removeAttribute('data-state');
              if (label) label.textContent = original;
            }, 2200);
          })
          .catch(function () {
            btn.setAttribute('data-state', 'error');
            if (label) label.textContent = FAIL;
            setTimeout(function () {
              btn.removeAttribute('data-state');
              if (label) label.textContent = original;
            }, 2600);
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
